import React from 'react'
import SinglePost from '../../components/singlepost/SinglePost'
import BottomNav from '../../components/bottomnav/BottomNav';
import Navbar from '../../components/navbar/Navbar';
import './single.css'
import { useContext } from "react";
import { Context } from "../../context/Context";


function Single() {
    const {user} = useContext(Context);  
    return (
        <>
        <Navbar/>
        <div className="single">
            <SinglePost/>   
               
        </div>
        {user &&  <BottomNav/>}
        </>
    )
}

export default Single
